import React, { Component } from 'react';
import Alert from 'react-s-alert'

class PopupVerify extends Component {

  printPdf(){
    return typeof(this.props.print)!=="undefined";
  }

  handlePrintPdf(e){
    if (this.printPdf()){
      this.props.print(this.props.info);
    }
  }

  render() {
    const printPdf = this.printPdf();
    return (
      <div className='popup verify components-CustomAlert'>
        <div className='popup_inner verify'>
          <button className='close' onClick={Alert.closeAll}></button>
          
          <h1>Tack</h1>
          <div>
            <span className='bold'>
              Order: {this.props.info.id} - {this.props.info.pallets} {this.props.info.pallets === 1 ? 'pall' : 'pallar'} - {this.props.info.weight}kg - Har nu registrerats.
            </span>
          </div>
          
          {
              this.props.info.shippingNo &&
                <div>
                    <span className='bold'>Sändningsnummer: </span><span>{this.props.info.shippingNo}</span>
                </div>
          }
          
          <div>
            <span>Du kan stänga fönstret eller skriva ut en kvittens</span>
          </div>

          {printPdf &&
            <button
              className='print btn text'
              onClick={(e)=>this.handlePrintPdf(e)} >
              <i className="fal fa-print"></i>Skriv ut kvittens
            </button>
          }

        </div>
      </div>
    );
  }
}

export default PopupVerify


// WEBPACK FOOTER //
// ./src/components/CustomAlert.js